export default "__VITE_ASSET__DA2bHhnu__"